import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import ReactPaginate from 'react-paginate'
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  FormGroup,
  Input,
  Label,
  Row,
  Table,
} from 'reactstrap'
import { api } from '../../utils'

const CLIENTI_PAGE_SIZE = 10

export default function ClientCreationList() {
  const [clienti, setClienti] = useState([])
  const [nomeFilter, setNomeFilter] = useState('')
  const [appliedNomeFilter, setAppliedNomeFilter] = useState('')
  const [actualPage, setActualPage] = useState(1)
  const [pages, setPages] = useState(0)

  useEffect(() => {
    const fetchClienti = async () => {
      const params = {
        page: actualPage,
        page_size: CLIENTI_PAGE_SIZE,
      }
      if (appliedNomeFilter) {
        params.nome = appliedNomeFilter
      }
      const response = await api.get('clienti/', { params })
      const payload = response.data

      if (Array.isArray(payload)) {
        setClienti(payload)
        setPages(Math.ceil(payload.length / CLIENTI_PAGE_SIZE))
        return
      }

      setClienti(payload?.results || [])
      setPages(Math.ceil((payload?.count || 0) / CLIENTI_PAGE_SIZE))
    }

    fetchClienti()
  }, [actualPage, appliedNomeFilter])

  const handlePageClick = ({ selected }) => {
    setActualPage(selected + 1)
  }

  return (
    <div className="header bg-gradient-info pb-8 pt-5 pt-md-8">
      <div className="container-fluid">
        <Row>
          <Col>
            <Card className="shadow">
              <CardHeader className="border-0 d-flex justify-content-between align-items-center">
                <h3 className="mb-0">Lista Clienti</h3>
                <Link to="/client-creation/create">Crea Cliente</Link>
              </CardHeader>
              <CardBody>
                <Row className="align-items-end mb-3">
                  <Col md={4}>
                    <FormGroup>
                      <Label for="client-creation-filter-name">Nome Cliente</Label>
                      <Input
                        id="client-creation-filter-name"
                        value={nomeFilter}
                        onChange={(event) => setNomeFilter(event.target.value)}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={8} className="text-right pb-3">
                    <Button
                      color="light"
                      className="mr-2"
                      onClick={() => {
                        setNomeFilter('')
                        setAppliedNomeFilter('')
                        setActualPage(1)
                      }}
                    >
                      Reset
                    </Button>
                    <Button
                      color="primary"
                      onClick={() => {
                        setAppliedNomeFilter(nomeFilter)
                        setActualPage(1)
                      }}
                    >
                      Apply
                    </Button>
                  </Col>
                </Row>

                <Table>
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Nome</th>
                    </tr>
                  </thead>
                  <tbody>
                    {clienti.map((cliente) => (
                      <tr key={cliente.id}>
                        <td>{cliente.id}</td>
                        <td>{cliente.nome}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                {pages > 1 && (
                  <ReactPaginate
                    previousLabel={'<'}
                    nextLabel={'>'}
                    breakLabel={'...'}
                    pageCount={pages}
                    forcePage={actualPage - 1}
                    onPageChange={handlePageClick}
                    containerClassName={'pagination justify-content-center pt-5 pb-3'}
                    pageClassName={'page-item'}
                    pageLinkClassName={'page-link'}
                    previousClassName={'page-item'}
                    previousLinkClassName={'page-link'}
                    nextClassName={'page-item'}
                    nextLinkClassName={'page-link'}
                    breakClassName={'page-item'}
                    breakLinkClassName={'page-link'}
                    activeClassName={'active'}
                  />
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  )
}
